import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import {
  EventqDialogPopover,
  EventqDialogPopoverPlacement,
} from '../dialog-popover/dialog-popover';
import {
  AI_FEEDBACK_VARIANTS,
  AiFeedbackConfirm,
  AiFeedbackVariant,
} from './ai-feedback-popover.types';
import { prefixUrl } from '../../utils/url.util';

export type {
  AiFeedbackConfirm,
  AiFeedbackVariant,
  AiFeedbackVariantConfig,
} from './ai-feedback-popover.types';
export { AI_FEEDBACK_VARIANTS } from './ai-feedback-popover.types';

@Component({
  selector: 'eventq-ai-feedback-popover',
  imports: [EventqDialogPopover],
  templateUrl: './ai-feedback-popover.html',
  styleUrl: './ai-feedback-popover.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqAiFeedbackPopover {
  readonly open = input(false);
  readonly variant = input.required<AiFeedbackVariant>();
  readonly detectionId = input.required<string>();
  readonly submitDisabled = input(false);
  readonly anchor = input<HTMLElement | null>(null);
  readonly placement = input<EventqDialogPopoverPlacement | 'auto'>('auto');
  readonly panelWidth = input<string | null>('280px');
  readonly cancelLabel = input('Cancel');
  readonly confirmLabel = input('Submit');

  readonly closed = output<void>();
  readonly confirm = output<AiFeedbackConfirm>();

  readonly resolvedPlacement = computed((): EventqDialogPopoverPlacement => {
    const placement = this.placement();
    if (placement !== 'auto') {
      return placement;
    }
    return this.anchor() ? 'anchor-right' : 'center';
  });

  readonly config = computed(() => {
    const variant = AI_FEEDBACK_VARIANTS[this.variant()];
    return {
      ...variant,
      iconSrc: prefixUrl(variant.iconSrc),
    };
  });

  onConfirm(): void {
    this.confirm.emit({ detectionId: this.detectionId(), variant: this.variant() });
  }
}
